<template>
    <div class="app-container">
        <div ref="drawer" class="drawer" :class="{ active: isOpen }">
            <div class="drawer-handle-container" @mousedown="startDrag" @touchstart="startDrag">
                <div class="drawer-handle"  />
            </div>


            <div class="drawer-content">
                <div class="flex-1 overflow-y-auto">

                    <div v-if="drawerData.interactionData" class="space-y-4">
                        <div class="p-4 bg-blue-50 rounded-lg">
                            <h3 class="font-semibold mb-2">{{ drawerData.interactionData.title }}</h3>
                            <p class="text-sm text-gray-600">
                                {{ drawerData.interactionData.description }}
                            </p>
                        </div>

                        <button
                            v-if="drawerData.interactionData && drawerData.interactionData.resource && drawerData.interactionData.resource.type === 'typeform'"
                            class="open-typeform w-full bg-[#272727] text-white px-4 py-3 rounded-lg hover:bg-black transition-colors font-medium"
                            @click="openopen">
                            {{ $t('open_survey') }}
                        </button>

                        <div v-else-if="drawerData.interactionData && drawerData.interactionData.resource && drawerData.interactionData.resource.type === 'video'"
                            class="space-y-2">
                            <video
                                v-if="drawerData.interactionData.resource && drawerData.interactionData.resource.videoUrl"
                                controls class="w-full rounded-lg">
                                <source :src="drawerData.interactionData.resource.videoUrl" type="video/mp4">
                                Tu navegador no soporta el elemento de video.
                            </video>
                            <p v-else class="text-gray-500 text-center p-4">
                                No hay video disponible
                            </p>
                        </div>

                        <div v-else-if="drawerData.interactionData && drawerData.interactionData.resource && drawerData.interactionData.resource.type === 'text'"
                            class="prose prose-sm max-w-none p-4 bg-gray-50 rounded-lg"
                            v-html="drawerData.interactionData.resource.customText" />

                        <div v-else class="p-4 text-center text-gray-500">
                            <p>Tipo de recurso no soportado:
                                {{ drawerData.interactionData.resource ? drawerData.interactionData.resource.type :
                                    'Desconocido' }}
                            </p>
                        </div>
                    </div>
                    <div v-else class="p-8 text-center text-gray-500">
                        <p>No hay datos disponibles</p>
                    </div>
                </div>

                <div class="mt-4 flex justify-center gap-2">
                    <button
                        class="closedraw px-4 py-2 bg-gray-300 text-black font-bold rounded transition-colors"
                        @click="closeDrawer">
                         {{ $t('close') }}
                    </button>
                </div>
            </div>
        </div>

        <!-- Modal SIN el div wrapper - esto estaba causando el problema -->
        <ModalCentered ref="modal" :modalData="modalDataToPass" @confirm="handleModalConfirm"
            @modal-closed="handleModalClosed" />
    </div>
</template>

<script>
import ModalCentered from './ModalCentered.vue';

export default {
    name: "Drawer",
    components: {
        ModalCentered
    },
    props: {
        // Esta prop ahora recibe el objeto completo de interacción del padre
        drawerData: {
            type: Object,
            // Asegúrate de que el default refleje la estructura esperada
            default: () => ({
                interactionData: null
            })
        }
    },
    data() {
        return {
            isOpen: false,
            startY: 0,
            currentY: 0,
            isDragging: false,
            modalDataToPass: null,
            // ELIMINADAS: loading, error, interactionData
            name: "Pedro Duarte",
            username: "@peduarte",
        };
    },
    // ELIMINADO: La sección 'watch'
    methods: {
        openDrawer() {
            this.isOpen = true;
            document.body.style.overflow = "hidden";
        },
        save() {
            alert("Cambios guardados!");
            this.closeDrawer();
        },
        // MANTENIDOS: startDrag, drag, endDrag (para la funcionalidad del cajón)
        startDrag(e) {
            this.isDragging = true;
            this.startY = e.type === "touchstart" ? e.touches[0].clientY : e.clientY;

            const drawer = this.$refs.drawer;
            drawer.style.transition = "none";

            // Prevenir el scroll del body mientras se arrastra
            if (e.type === "touchstart") {
                document.body.style.touchAction = "none";
            }

            document.addEventListener("mousemove", this.drag);
            document.addEventListener("touchmove", this.drag, { passive: false });
            document.addEventListener("mouseup", this.endDrag);
            document.addEventListener("touchend", this.endDrag);
        },

        drag(e) {
            if (!this.isDragging) return;

            // Prevenir el comportamiento por defecto en touch
            if (e.type === "touchmove") {
                e.preventDefault();
            }

            this.currentY = e.type === "touchmove" ? e.touches[0].clientY : e.clientY;
            const diff = this.currentY - this.startY;
            const drawer = this.$refs.drawer;

            // Solo permitir arrastrar hacia abajo
            if (diff > 0) {
                const transform = `translateY(${diff}px)`;
                drawer.style.transform =
                    window.innerWidth >= 768
                        ? `translateX(-50%) ${transform}`
                        : transform;
            }
        },

        endDrag() {
            if (!this.isDragging) return;

            const diff = this.currentY - this.startY;
            const drawer = this.$refs.drawer;

            // Restaurar touch-action
            document.body.style.touchAction = "";

            // Obtener la altura del drawer
            const drawerHeight = drawer.offsetHeight;

            // Forzar la transición antes de cambiar el transform
            drawer.style.transition = "transform 0.4s cubic-bezier(0.32, 0.72, 0, 1)";

            // Si arrastró más de la tercera de la altura, cerrar
            if (diff > drawerHeight / 3) {
                // Forzar el cierre completo
                const closeTransform = window.innerWidth >= 768
                    ? "translateX(-50%) translateY(100%)"
                    : "translateY(100%)";

                drawer.style.transform = closeTransform;

                // Esperar a que termine la animación antes de cambiar el estado
                setTimeout(() => {
                    this.closeDrawer();
                }, 400); // 400ms = duración de la transición
            } else {
                // Si no llegó a la mitad, volver a la posición original
                drawer.style.transform =
                    window.innerWidth >= 768
                        ? "translateX(-50%) translateY(0)"
                        : "translateY(0)";
            }

            this.isDragging = false;
            document.removeEventListener("mousemove", this.drag);
            document.removeEventListener("touchmove", this.drag);
            document.removeEventListener("mouseup", this.endDrag);
            document.removeEventListener("touchend", this.endDrag);
        },

        closeDrawer() {
            const drawer = this.$refs.drawer;

            // Asegurar que la transición esté activa
            if (drawer) {
                drawer.style.transition = "transform 0.4s cubic-bezier(0.32, 0.72, 0, 1)";
                drawer.style.transform = "";
            }

            this.isOpen = false;
            document.body.style.overflow = "";
            document.body.style.touchAction = "";
        },

        openopen() {
            console.log('🚀 Abriendo modal con typeform');
            // Verificar que existe el typeFormId
            if (this.drawerData.interactionData?.resource?.typeFormId) {
                // Asignar los datos al modalData
                this.modalDataToPass = this.drawerData.interactionData;

                // Abrir el modal usando la ref correcta "modal"
                this.$nextTick(() => {
                    this.closeDrawer();
                    this.$refs.modal.openModal(this.drawerData.interactionData);
                });
            } else {
                console.error('❌ No se encontró typeFormId en la data');
                console.log('Estructura recibida:', this.drawerData.interactionData);
            }
        },
        handleModalConfirm(data) {
            console.log('Confirmado:', data);
        },
        handleModalClosed() {
            console.log('Modal cerrado');
        }
    },
};
</script>

<style scoped>
/* Pegado directo de tus estilos */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.app-container {
    background: #f5f5f5;
}

.trigger-btn {
    margin: 20px;
    padding: 12px 18px;
    background: #111;
    color: #fff;
    border-radius: 6px;
    border: none;
    cursor: pointer;
}

/* Overlay + Drawer */
.drawer-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease;
    z-index: 999;
}

.drawer-overlay.active {
    opacity: 1;
    visibility: visible;
}

.drawer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    border-radius: 24px 24px 0 0;
    padding: 20px;
    transform: translateY(100%);
    transition: transform 0.4s cubic-bezier(0.32, 0.72, 0, 1);
    z-index: 1000;
    max-height: 65vh;
    min-height: 60vh;
    overflow-y: auto;
    box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.2);
    will-change: transform;
    -webkit-overflow-scrolling: touch;
}

.drawer.active {
    transform: translateY(0);
}

.drawer-handle {
    width: 48px;
    height: 5px;
    background: #d1d5db;
    border-radius: 3px;
    margin: 0 auto 20px;
    cursor: grab;
}

.drawer-handle-container {
    height: 3dvh;
}

@media (min-width: 768px) {
    .drawer {
        left: 50%;
        transform: translateX(-50%) translateY(100%);
        max-width: 500px;
        border-radius: 24px;
    }

    .drawer.active {
        transform: translateX(-50%) translateY(0);
    }
}

/* Contenedor principal del contenido, ocupa el espacio restante y permite scroll */
.flex-1 {
    flex: 1 1 0%;
}

.overflow-y-auto {
    overflow-y: auto;
}

/* Flexbox utilities para centrado */
.flex {
    display: flex;
}

.items-center {
    align-items: center;
}

.justify-center {
    justify-content: center;
}

.justify-center {
    justify-content: center;
}

.text-center {
    text-align: center;
}

.gap-2 {
    gap: 0.5rem;
    /* 8px */
}

/* Padding y Margin */
.p-8 {
    padding: 2rem;
    /* 32px */
}

.p-4 {
    padding: 1rem;
    /* 16px */
}

.mb-4 {
    margin-bottom: 1rem;
    /* 16px */
}

.mb-2 {
    margin-bottom: 0.5rem;
    /* 8px */
}

.mt-4 {
    margin-top: 1rem;
    /* 16px */
}

.mx-auto {
    margin-left: auto;
    margin-right: auto;
}

/* Estilos de Tipografía y color */
.text-gray-600 {
    color: #4b5563;
    /* Gris de Tailwind */
}

.text-red-600 {
    color: #dc2626;
    /* Rojo de Tailwind */
}

.text-gray-500 {
    color: #6b7280;
    /* Gris de Tailwind */
}

.text-sm {
    font-size: 0.875rem;
    /* 14px */
    line-height: 1.25rem;
    /* 20px */
}

.font-semibold {
    font-weight: 600;
}

.font-medium {
    font-weight: 500;
}

.font-bold {
    font-weight: 700;
}

.text-white {
    color: #ffffff;
}

.text-black {
    color: #000000;
}

/* Estilos de Layout y bordes */
.w-full {
    width: 100%;
}

.h-12 {
    height: 3rem;
    /* 48px */
}

.w-12 {
    width: 3rem;
    /* 48px */
}

.rounded-full {
    border-radius: 9999px;
}

.rounded {
    border-radius: 0.25rem;
    /* 4px */
}

.rounded-lg {
    border-radius: 0.5rem;
    /* 8px */
}

/* Estilos del SPINNER (Loading) */
.animate-spin {
    animation: spin 1s linear infinite;
}

.border-b-2 {
    border-bottom-width: 2px;
}

.border-blue-600 {
    border-color: #2563eb;
    /* Azul de Tailwind */
}

/* Fondo y Colores del contenido */
.bg-blue-50 {
    background-color: #eff6ff;
    /* Azul muy claro de Tailwind */
}

.bg-blue-600 {
    background-color: #2563eb;
    /* Azul de Tailwind */
}

.bg-gray-50 {
    background-color: #f9fafb;
    /* Gris muy claro de Tailwind */
}

.bg-gray-300 {
    background-color: #d1d5db;
    /* Gris de Tailwind */
}

/* Estilos Específicos (Botón Typeform) */
.bg-\[\#272727\] {
    background-color: #272727;
    /* Gris oscuro específico */
}

.hover\:bg-black:hover {
    background-color: #000000;
}

.transition-colors {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}

/* Espaciado de contenido */
.space-y-4> :not([hidden])~ :not([hidden]) {
    margin-top: 1rem;
    /* 16px */
    margin-bottom: 0;
}

.space-y-2> :not([hidden])~ :not([hidden]) {
    margin-top: 0.5rem;
    /* 8px */
    margin-bottom: 0;
}

/* Estilos de TIPOGRAFÍA/PROSE (Markdown/HTML de texto) */
/* Nota: Tailwind 'prose' es complejo. Esta es una versión simplificada de lo que se usa en el código. */
.prose {
    /* Estilos base para contenido de texto formateado (headings, p, ul, etc.) */
    color: #374151;
    /* text-gray-700 */
    line-height: 1.75;
}

.prose-sm {
    /* Estilos de tamaño pequeño para el bloque de texto */
    font-size: 0.875rem;
    /* text-sm */
    line-height: 1.5;
}

.max-w-none {
    max-width: none;
}

.closeButton {
    padding: .8em 2em;
    border-radius: 10px;
    border: none;

}

.modal-container {}

.modal-centered {}

.open-typeform {
    padding: .6em 0em;
    color: rgb(234, 234, 234);
}

.closedraw {
    position: absolute;
    bottom: 2dvh;
    border: none;
    padding: .6em 1.2em;
}

/* Definición del Keyframe para la animación del spinner */
@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>